import DBEngine from '@/database/_Base';
import SyncEngine from '@/database/_Sync';

const tableName = 'job';

const functions = {
    async get() {
        await this.sync();
        
        return await DBEngine.getContentList(tableName);
    },
    async sync() {
        // Sync Data with Server
        await SyncEngine.syncDataVersion(tableName);
    },
    async getDetail(key) {
        const currentData = await this.get();
        
        return await DBEngine.getContentDetailByKey(currentData, key);
    },
    async getDetailByNumber(number, type) {
        const currentData = await this.get();

        if (currentData.content && currentData.content.length > 0) {
            return currentData.content.find(x => x.number === number && x.jobType === type);
        }

        return null
    },
    async save(value) {
        const currentData = await this.get();

        await DBEngine.updateListData(tableName, currentData, value, (value.key ? DBEngine.syncAction().update : DBEngine.syncAction().add));
    },
    async delete(item) {
        const currentData = await this.get();

        await DBEngine.updateListData(tableName, currentData, item, DBEngine.syncAction().delete);
    }
}

export default functions;